import { EmployeeProfile } from "../../../profile/models/profileModels";

export const removeChecked = (data: any[]) => {
  return data
    ? data.map((item: any) => {
        let { isChecked, ...dataRemoved } = item;
        return dataRemoved;
      })
    : data;
};

export const convertEmployeeId = (employeeList: EmployeeProfile[]) => {
  return employeeList
    ? employeeList.map((employee) => {
        let { id, ...employeeFilter } = employee;
        return { ...employeeFilter, employeeId: id };
      })
    : [];
};
